export default __webpack_public_path__ + "static/media/bundle.90575aa1.svg";